import RegisterResult from "pages/LandingPages/FormRegisterResult";

export default function RegisterResultPage() {
  return <RegisterResult />;
}
